import styled from 'foundations-theming/utils';
import { createContext, useContext, useMemo } from 'react';
import { TABLE_MARGIN_BOTTOM } from 'framework-listing-lib/constants/sizes';
import useTableDimensions from 'framework-listing-lib/internal/Table/hooks/useTableDimensions';
import { jsx as _jsx } from "react/jsx-runtime";
const CELL_PADDING_X = 24;
const TableContainer = styled.div.attrs({
  'data-test-id': 'crm-table-wrapper'
}).withConfig({
  displayName: "FrameworkDataTablePassThroughPropsProvider__TableContainer",
  componentId: "sc-1febvo2-0"
})(["flex:1 1 auto;overflow:auto;display:flex;flex-direction:column;position:relative;min-height:200px;.width-100{width:100%;}tr[data-test-id='crm-table-row']{&[aria-invalid]{&:hover{background-color:", ";}}&[data-test-nested-level='1']{td[data-test-is-nested='true'][data-test-col-index='0']{background:linear-gradient( to right,rgba(0,0,0,0) 35px,", " 0,", " 50px,rgba(0,0,0,0) 50px );padding-left:", "px;}}&[data-test-nested-level='2']{td[data-test-is-nested='true'][data-test-col-index='0']{background:linear-gradient( to right,rgba(0,0,0,0) 35px,", " 0,", " 50px,rgba(0,0,0,0) 50px );padding-left:", "px;}}}"], ({
  theme
}) => theme.color['do-not-use-candy-apple-light'], ({
  theme
}) => theme.color['do-not-use-koala'], ({
  theme
}) => theme.color['do-not-use-koala'], 40 + CELL_PADDING_X, ({
  theme
}) => theme.color['do-not-use-koala'], ({
  theme
}) => theme.color['do-not-use-koala'], 80 + CELL_PADDING_X);
const FrameworkDataTablePassThroughPropsContext = /*#__PURE__*/createContext(undefined);
export default function FrameworkDataTablePassThroughPropsProvider({
  data,
  children,
  maxHeight,
  renderNestedContent,
  renderPqlRow,
  rowProps,
  tableColumns,
  columns
}) {
  const {
    height,
    refCallback
  } = useTableDimensions({
    heightAffordances: TABLE_MARGIN_BOTTOM,
    maxHeight
  });
  const value = useMemo(() => ({
    columns,
    data,
    renderNestedContent,
    renderPqlRow,
    rowProps,
    tableColumns
  }), [columns, data, renderNestedContent, renderPqlRow, rowProps, tableColumns]);
  return /*#__PURE__*/_jsx(FrameworkDataTablePassThroughPropsContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsx(TableContainer, {
      ref: refCallback,
      style: {
        height
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "crm-table",
        "data-test-crmui": true,
        style: {
          height
        },
        children: children
      })
    })
  });
}
export function useTablePassThroughProps() {
  const context = useContext(FrameworkDataTablePassThroughPropsContext);
  if (context === undefined) {
    throw new Error('useTablePassThroughProps must be used within a FrameworkDataTablePassThroughPropsProvider');
  }
  return context;
}